/* Dummy student data for the eleve dashboard / pages (parcours, compétences). */
/* Placeholder content — to be replaced by real data once the parcours & */
/* competences backend exists. */

export interface DummyParcours {
  id: string;
  title: string;
  subject: string;
  /** Short subject tag shown in a colored badge (no emoji). */
  tag: string;
  progress: number; /* 0..100 */
  nextStep?: string;
  color: string;
}

export const PARCOURS_EN_COURS: DummyParcours[] = [
  { id: 'p-frac', title: 'Les fractions', subject: 'Mathématiques', tag: 'MA', progress: 65, nextStep: 'Additionner deux fractions', color: '#2170e4' },
  { id: 'p-conj', title: 'Le présent de l’indicatif', subject: 'Français', tag: 'FR', progress: 40, nextStep: 'Les verbes du 2ᵉ groupe', color: '#00a673' },
  { id: 'p-volc', title: 'Volcans & séismes', subject: 'SVT', tag: 'SVT', progress: 80, nextStep: 'Quiz final', color: '#b8430f' },
];

export const PARCOURS_RECOMMANDES: DummyParcours[] = [
  { id: 'r-geo', title: 'Périmètres & aires', subject: 'Mathématiques', tag: 'MA', progress: 0, color: '#6750a4' },
  { id: 'r-eng', title: 'Se présenter en anglais', subject: 'Anglais', tag: 'EN', progress: 0, color: '#0058be' },
  { id: 'r-hist', title: 'La Révolution française', subject: 'Histoire', tag: 'HG', progress: 0, color: '#8a5a00' },
  { id: 'r-poesie', title: 'Écrire un poème', subject: 'Français', tag: 'FR', progress: 0, color: '#00786b' },
];

export interface DummyCompetence {
  id: string;
  label: string;
  domain: string;
  level: number; /* 0..4 (non acquis → expert) */
}

export const COMPETENCES: DummyCompetence[] = [
  { id: 'c1', label: 'Calculer avec des fractions', domain: 'Nombres & calcul', level: 3 },
  { id: 'c2', label: 'Conjuguer au présent', domain: 'Grammaire', level: 2 },
  { id: 'c3', label: 'Décrire un phénomène naturel', domain: 'Sciences', level: 4 },
  { id: 'c4', label: 'Lire une carte', domain: 'Géographie', level: 1 },
  { id: 'c5', label: 'Rédiger un court texte', domain: 'Expression écrite', level: 2 },
];

export const COMPETENCE_LEVELS = ['Non acquis', 'En cours', 'Acquis', 'Maîtrisé', 'Expert'];
